import lotteryApi from '@/api/lottery'

const state = {
  scanTimes: 0,
  lotteryCode: '',
  lotteryCount: 0,
  scanCountMonth: 0,
  scanCountCurrent: 0,
  couponCount: 0,
  couponCountAll: 0,
  scanPoint: 0,
  springActivityData: '',
  cardsValue: '',
  hasCollectAll: false,
  castrolPoint: 0,
  offlineCoupon: ''
}

const mutations = {
  setScanCountCurrent (state, value) {
    state.scanCountCurrent++
  },
  setCouponCount (state, value) {
    state.couponCount = value
  },
  setCouponCountAll (state, value) {
    state.couponCountAll = value
  },
  setLotteryData (state, value) {
    state.scanTimes = value.activityScanLottery.scanCount
    if (value.activityScanLottery.lotteryCode) {
      // 卡券编码
      state.lotteryCode = value.activityScanLottery.lotteryCode
    }
    // 获取卡券数
    state.lotteryCount = value.lotteryCountForMonth
    // 月累计扫码数
    state.scanCountMonth = value.countQrCodeForMonth
    // 获得积分
    state.scanPoint = value.scanInfo.bonusPointValue
    // 是否获取线下券
    state.offlineCoupon = value.offlineCoupon
  },
  setCastrolData (state, value) {
    state.castrolPoint = value.scanInfo.bonusPointValue
  },
  setCollectCardsData (state, value) {
    state.springActivityData = ''
    state.cardsValue = ''
    if (value) {
      state.springActivityData = Object.assign({}, value)
      switch (value.bonusLetter.toUpperCase()) {
        case 'C':
          state.cardsValue = '500'
          break
        case 'N':
          state.cardsValue = '1000'
          break
        case 'H':
          state.cardsValue = '1500'
          break
        case 'K':
          state.cardsValue = '2000'
          state.hasCollectAll = true
      }
    }
  }
}

const actions = {
  getCouponCount ({ commit, state }) {
    lotteryApi.getCouponCount().then(res => {
      if (res.data.resultCode === '0') {
        commit('setCouponCount', res.data.resultData.lotteryCount)
        commit('setCouponCountAll', res.data.resultData.lotteryCountAll)
        if (state.couponCount > 99) {
          state.couponCount = '99+'
        }
        if (state.couponCountAll > 999) {
          state.couponCountAll = '999+'
        }
      }
    })
  }
}

export default {
  state,
  mutations,
  actions
}
